/* @flow */
import {INIT} from './action-types';

export const init = () => ({ type: INIT });



// WEBPACK FOOTER //
// ./src/app/modules/metrics/actions.js